import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./style/index.scss";

const NODE_ENV = process.env.REACT_APP_NODE_ENV;
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

async function enableMocking() {
	if (!NODE_ENV || NODE_ENV !== "development") {
		return;
	}

	const { worker } = await import("./mocks/browser");

	return worker.start();
}

Sentry.init({
	dsn: SENTRY_DSN,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	beforeSend(event, hint) {
		const error = hint?.originalException;

		if (error instanceof Error && error.message.includes("updateFrom")) {
			// 非預期但可忽略的錯誤，不上報
			return null;
		}

		return event;
	},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
enableMocking().then(() => {
	root.render(
		<Sentry.ErrorBoundary
			fallback={<p>An unexpected error occurred, please try again later.</p>}
		>
			<App />,
		</Sentry.ErrorBoundary>,
	);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
